import { render, staticRenderFns } from "./grammar-directory-card.vue?vue&type=template&id=0f5d9db1&scoped=true&"
import script from "./grammar-directory-card.vue?vue&type=script&lang=js&"
export * from "./grammar-directory-card.vue?vue&type=script&lang=js&"
import style0 from "./grammar-directory-card.vue?vue&type=style&index=0&id=0f5d9db1&lang=scss&scoped=true&"
import style1 from "./grammar-directory-card.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5d9db1",
  null
  
)

export default component.exports